var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanoramicMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 62,
    viewBox: "0 0 56 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0324 10.1743C36.4029 8.54476 33.7696 8.54476 32.14 10.1743L6.99657 35.3177C5.36703 36.9473 5.36703 39.5806 6.99657 41.2102L17.7063 51.9199C19.2819 53.5298 21.9121 53.5525 23.595 51.9083C23.5962 51.9072 23.5974 51.906 23.5986 51.9049L48.7345 26.7688C50.3641 25.1393 50.3641 22.5059 48.7345 20.8764L38.0324 10.1743ZM30.7258 8.7601C33.1364 6.3495 37.0361 6.3495 39.4467 8.7601L50.1487 19.4622C52.5593 21.8728 52.5593 25.7724 50.1487 28.183L24.9979 53.3339C22.5559 55.725 18.6586 55.7479 16.2808 53.3228C16.2795 53.3215 16.2782 53.3202 16.2769 53.3188L5.58236 42.6244C3.17177 40.2138 3.17177 36.3141 5.58236 33.9035L30.7258 8.7601Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6273 28.4544C55.1787 28.4223 55.6516 28.8433 55.6837 29.3946C56.1293 37.0598 53.4109 44.9065 47.5701 50.7473C41.6854 56.632 33.8813 59.3065 26.2174 58.8609C25.666 58.8289 25.2451 58.3559 25.2771 57.8046C25.3092 57.2532 25.7821 56.8322 26.3335 56.8643C33.4548 57.2783 40.6937 54.7952 46.1558 49.3331C51.5758 43.9131 54.101 36.6308 53.687 29.5107C53.655 28.9594 54.076 28.4864 54.6273 28.4544Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16267 11.3382C14.0472 5.45444 21.8507 2.78037 29.514 3.22591C30.0653 3.25797 30.4863 3.73092 30.4543 4.28227C30.4222 4.83362 29.9492 5.2546 29.3979 5.22254C22.2766 4.80851 15.0376 7.29162 9.57551 12.7537L9.57282 12.7564C4.11488 18.173 1.63015 25.4525 2.04432 32.5761C2.07637 33.1275 1.6554 33.6004 1.10404 33.6325C0.552689 33.6645 0.0797422 33.2436 0.0476867 32.6922C-0.397722 25.0312 2.27474 17.1823 8.16267 11.3382Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3961 0.568548C23.6345 0.0703736 24.2316 -0.140206 24.7298 0.0982067L30.747 2.97788C31.069 3.132 31.2845 3.4461 31.3123 3.80202C31.3401 4.15794 31.176 4.50169 30.8818 4.70395L25.3804 8.48621C24.9253 8.7991 24.3027 8.6838 23.9898 8.2287C23.6769 7.77359 23.7922 7.15101 24.2473 6.83813L28.3239 4.03548L23.8664 1.90226C23.3682 1.66384 23.1576 1.06672 23.3961 0.568548Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3861 53.7715C32.699 54.2266 32.5837 54.8491 32.1286 55.162L28.052 57.9647L32.5095 60.0979C33.0076 60.3363 33.2182 60.9334 32.9798 61.4316C32.7414 61.9298 32.1443 62.1404 31.6461 61.9019L25.6289 59.0223C25.3068 58.8682 25.0914 58.5541 25.0636 58.1981C25.0358 57.8422 25.1998 57.4985 25.494 57.2962L30.9955 53.5139C31.4506 53.2011 32.0732 53.3163 32.3861 53.7715Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3448 40.3484C11.7368 39.9593 12.37 39.9617 12.759 40.3536L18.5184 46.156C18.9075 46.5479 18.9051 47.1811 18.5131 47.5702C18.1212 47.9592 17.488 47.9569 17.0989 47.5649L11.3396 41.7626C10.9505 41.3706 10.9529 40.7374 11.3448 40.3484Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0756 15.4223C38.4661 15.0318 39.0993 15.0318 39.4898 15.4223L43.444 19.3765C43.8345 19.767 43.8345 20.4002 43.444 20.7907C43.0535 21.1812 42.4203 21.1812 42.0298 20.7907L38.0756 16.8365C37.6851 16.446 37.6851 15.8128 38.0756 15.4223Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanoramicMode);
export default __webpack_public_path__ + "static/media/panoramic-mode.2b059b302243ae8ad5d26d783405399d.svg";
export { ForwardRef as ReactComponent };